import React, { useEffect, useRef, useState } from "react";
import {
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";




const CollegeUniversityCoursesFeesStep3 = ({ data, setData, setCurrentStep, currentStep }) => {
  const navigate = useNavigate();
  const initialValues = {
    hostelFeeStructureHeading: data?.hostelFeeStructureHeading,
    hostelFeeStructures: data?.hostelFeeStructures
  }
  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep + 1)

    try {
      setFormDataLoading(true);
      const res = await updateCollegeDetails(data?._id, formData);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        // toast.success(res?.message);
        setFormData(initialValues)
        setFormDataLoading(false);
        setData({
          ...data,
          hostelFeeStructureHeading: formData?.hostelFeeStructureHeading,
          hostelFeeStructures: formData?.hostelFeeStructures
        })
        // setCurrentStep(currentStep)
        navigate("/manage-college-university");
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  /////////////////////////////////////
  const initialItem = {
    category: "",
    approxCost: ""
  };

  const initialItems = data?.hostelFeeStructures?.length ? data?.hostelFeeStructures : [initialItem]

  const [items, setItems] = useState(initialItems);
  const handleMultiChange = (i, e) => {
    let newFormValues = [...items];
    newFormValues[i][e.target.name] = e.target.value;
    setItems(newFormValues);
    setFormData({ ...formData, hostelFeeStructures: newFormValues })
  };

  const addItem = () => {
    if (items?.length < 5000) {
      setItems([...items, initialItem]);
    }
  };

  const removeProducts = (i) => {
    let newFormValues = [...items];
    newFormValues.splice(i, 1);
    setItems(newFormValues);
    setFormData({ ...formData, hostelFeeStructures: newFormValues })
  };

    useEffect(() => {
      setFormData(initialValues)
    }, [data])

  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">





            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Hostel Fees Structure Heading<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData?.hostelFeeStructureHeading}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    hostelFeeStructureHeading: e?.target?.value,
                  }));
                }}
                placeholder="Enter Heading Text"
              />
            </div>

            <div className="col-md-12 mt-3">
              <label>
                Course Events <button
                  className="btn btn-sm btn-success"
                  type="button"
                  onClick={() => addItem()}
                >
                  <i class="fas fa-plus"></i> Add
                </button>
              </label>
              {items?.map((element, index) => (

                <div
                  // style={{ border: "solid 1px #ced4da", padding: "1em", margin: "0 0 1em 0", borderRadius: "0.25rem" }}
                  className="_form-inline row" key={index}>

                  <div className="col-md-8 mb-2 mt-1">
                    <label>
                      Category:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="category"
                      placeholder={`Event ${index + 1}`}
                      value={element.category || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-4 mb-2 mt-1">
                    <label>
                      Approximate Cost:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="approxCost"
                      placeholder={`Cost ${index + 1}`}
                      value={element.approxCost || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  {index ? (
                    <div
                      style={{
                        position: "absolute",
                        right: "25px"
                      }}
                    >
                      <i class="fas fa-times"
                        style={{
                          color: "#ff0000",
                          cursor: "pointer",
                          fontSize: "1em"
                        }}
                        onClick={() => removeProducts(index)}
                      ></i>
                    </div>
                  ) : null}




                </div>

              ))}
            </div>

          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 1 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityCoursesFeesStep3;
